module.exports = __webpack_public_path__ + "static/media/red-bg-square.569657a3.webp";